"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function quizSessionIncludesModule(session, moduleStat) {
    return session.contentIds.includes(moduleStat.contentId);
}
exports.default = quizSessionIncludesModule;
